import { Icon, IconProps } from '../Icon'

export const QuestionIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      help
    </Icon>
  )
}
